import { ROLES } from 'src/constants/Role';
import { UserApiResponse } from 'src/types/user';

/** Keep platform navigation independent of the selected workspace's role. */
export const canAccessDashboardRoles = (
  user: Pick<UserApiResponse, 'role' | 'hasPlatformSuperAdminAccess'>,
  allowedRoles: readonly (keyof typeof ROLES)[],
): boolean => {
  if (allowedRoles.length === 1 && allowedRoles[0] === ROLES.SUPER_ADMIN) {
    // Older servers omit the capability. An explicit false is authoritative.
    return user.hasPlatformSuperAdminAccess ?? user.role === ROLES.SUPER_ADMIN;
  }

  return allowedRoles.includes(user.role);
};
